import axios from 'axios'
import {useCallback, useEffect, useState} from 'react'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {Menu} from './models/Menu'
import {useSubmenu} from '../header/SubmenuContext'

export function AsideMenuMain() {
    const {submenuType} = useSubmenu()
    const [dataMenu, setDataMenu] = useState<Menu>()

    const getMenu = useCallback(async () => {
        const {data} = await axios.get<Menu>(`/get_routes?submenu_type=${submenuType}`)
        setDataMenu(data)
    }, [submenuType])

    function Line({title}: {title?: string}) {
        return (
            <div className='menu-item'>
                <div className='menu-content py-2'>
                    <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                        {title}
                    </span>
                </div>
            </div>
        )
    }

    useEffect(() => {
        getMenu()
    }, [getMenu])

    return (
        <>
            {dataMenu?.pages.map((item, index) => (
                <div key={'divMenu.' + item.id}>
                    <Line title={item.section} />
                    {item.routes.map((route, indexRouter) =>
                        !route.root ? (
                            <AsideMenuItemWithSub
                                key={route.id + '.sub'}
                                to={route.page}
                                title={route.title}
                                fontIcon='bi-archive'
                                icon={route.icon}
                            >
                                {route.submenu?.map((subItem, subIndex) => (
                                    <AsideMenuItem
                                        key={indexRouter + '.' + subIndex}
                                        to={subItem.page}
                                        title={subItem.title}
                                        hasBullet={true}
                                    />
                                ))}
                            </AsideMenuItemWithSub>
                        ) : (
                            <AsideMenuItem
                                key={route.id + '.item'}
                                to={route.page}
                                icon={route.icon}
                                title={route.title}
                                fontIcon='bi-app-indicator'
                            />
                        )
                    )}
                </div>
            ))}
        </>
    )
}
